export default {
    getAllUsers: () => {
        return {
            url: '/fhe/users',
            method: 'GET'
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Users/api.js